<template>
    <button :class="btnClasses" @click.prevent="onClickBtnPDF" :disabled="btnIsDisabled" v-html="btnText"></button>
</template>

<script>
import axios from 'axios'

export default {
    props: ['btnText', 'btnClasses', 'ajaxAction', 'fileName', 'mimeType'],

    data() {
        return {
            ajaxObj: window.ajax_object,
            btnIsDisabled: false
        }
    },

    methods: {
		onClickBtnPDF() {
			let url = this.ajaxObj.ajax_url
            this.btnIsDisabled = true
			axios.get(url,
			{
				params: {
					_nounce_value: this.ajaxObj._nounce_value,
					action: this.ajaxAction,
					fileName: this.fileName
				}
			})
			.then((response) => {
				// console.log(response.data)
				if(response.data.error == '') {
					this.downloadPdf(response.data.url, response.data.file_name)
				}
			})
			.catch((err) => {
				console.log(err)
                this.btnIsDisabled = false
			})
		},

		downloadPdf(url, fileName) {
			axios.get(url,
				{
					responseType: 'blob',
					headers: {
						'Accept': this.mimeType
					}
				})
				.then((response) => {
					const downloadUrl = window.URL.createObjectURL(new Blob([response.data]))
					const link = document.createElement('a')
					link.href = downloadUrl
					link.setAttribute('download', fileName)
					document.body.appendChild(link)
					link.click()
					link.remove()
                    this.btnIsDisabled = false

					this.callBackCall()
				})
				.catch((err) => {
					console.log(err)
                    this.btnIsDisabled = false
				})
		},

		callBackCall() {
			this.$emit('onCallBack')
		}
    }
}
</script>